export default __webpack_public_path__ + "static/media/Xô-boi-abre-semtextura.91d5c204.jpg";